import { makeStyles } from "@material-ui/styles";

export type BadgeIntent = "neutral" | "warning";

const useStyles = makeStyles({
  Badge: {
    display: "inline-flex",
    alignItems: "center",
    // Inert outside a flex parent; keeps the badge from stretching to a header's full height
    alignSelf: "center",
    gap: "4px",
    flexShrink: 0,
    padding: "2px 8px",
    borderRadius: "10px",
    border: "1px solid",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    whiteSpace: "nowrap",
  },
  neutral: {
    borderColor: "rgba(255, 255, 255, 0.4)",
    color: "rgba(255, 255, 255, 0.85)",
  },
  // Amber rather than red: the member's data being elsewhere is not an error, and a red
  // badge beside a member's name reads as a clinical alert about the member.
  warning: {
    borderColor: "#e5a50a",
    backgroundColor: "rgba(229, 165, 10, 0.15)",
    color: "#ffcf5c",
  },
});

interface BadgeProps {
  text: string;
  intent?: BadgeIntent;
  title?: string;
}

/**
 * A short fact about what is on screen, in the style of a tag. Carries its value as text
 * so a finer region, or one meaning the data is held once for the whole platform, needs
 * no change here.
 */
export default function Badge({ text, intent = "neutral", title }: BadgeProps) {
  const styles = useStyles();

  return (
    <span className={`${styles.Badge} ${styles[intent]}`} title={title}>
      {text}
    </span>
  );
}
